module.exports = __webpack_public_path__ + "5ad32cc1fa505ebc072bc487139353d5.png";